import {
  keepPreviousData,
  type QueryFunctionContext,
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { api } from '@/api';
import { END_POINT } from '@/constants/end-point.constants';
import { ORGANIZATION_SHOPS_QUERY_KEYS } from '@/constants/query-keys.constants';

import type { OrganizationShopsResponse } from '../types';

const fetchOrganizationShops = ({
  queryKey: [{ filters, id }],
}: QueryFunctionContext<
  ReturnType<(typeof ORGANIZATION_SHOPS_QUERY_KEYS)['list']>
>): Promise<AxiosResponse<OrganizationShopsResponse>> =>
  api.get(END_POINT.organizationShop(id!), { params: filters });

export const useOrganizationShops = (
  id: string,
  filters?: unknown,
  useQueryOptions?: Partial<UseQueryOptions>,
) => {
  const { enabled = true } = useQueryOptions ?? {};

  return useQuery({
    queryKey: ORGANIZATION_SHOPS_QUERY_KEYS.list(filters, id),
    queryFn: enabled ? fetchOrganizationShops : skipToken,
    placeholderData: keepPreviousData,
    select: data => data.data,
  });
};
